import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
export default function PRZImageT({ isInternalLink, isExternalLink, className, src, alt, internalUrl, externalUrl, onClick, style, loading = 'lazy', }) {
    return (isInternalLink || isExternalLink) ? (_jsx(Link, { to: internalUrl || externalUrl || '#', children: _jsx("img", { src: src, loading: loading, alt: alt, className: className }) })) : (_jsx("img", { src: src, alt: alt, className: className, onClick: onClick, style: style, loading: loading }));
}
